import { Paper, styled } from '@mui/material';

export const NodeWrapperStyled = styled(Paper)(({ theme }) => ({
  width: '350px',
  outline: 'none',
  borderRadius: '12px',

  '&:hover': {
    borderColor: theme.palette.grey[800],
  },
  '&:focus': {
    borderColor: theme.palette.primary.main,
  },
  '&:active': {
    borderColor: theme.palette.primary.main,
  },
}));
